import type { Locale } from "./config";

/** BCP-47 locales used for Intl number/currency formatting per UI language. */
const INTL_LOCALES: Record<Locale, string> = {
  en: "en-GB",
  ar: "ar-SA",
  bn: "bn-BD",
};

/** Map a UI language code to an Intl locale for number/currency formatting. */
export function toIntlLocale(lang?: string): string {
  return INTL_LOCALES[(lang as Locale) ?? "en"] ?? "en-GB";
}

/**
 * Locale used for date formatting. `ar-SA` defaults to the Islamic (Umm
 * al-Qura) calendar in V8; order/wishlist dates are Gregorian, so pin the
 * calendar explicitly to avoid surprising Hijri dates.
 */
export function toIntlDateLocale(lang?: string): string {
  const locale = toIntlLocale(lang);
  return locale === "ar-SA" ? "ar-SA-u-ca-gregory" : locale;
}
